import { List } from 'react-bootstrap-icons';
import { useDispatch } from 'react-redux';
import { open } from '../../client-redux/sidebarHandle';

export const SidebarButton = () => {
  const dispatch = useDispatch();

  return <List width="26px" height="31px" onClick={() => dispatch(open())}></List>;
};
